import { Pipe, PipeTransform } from '@angular/core';

import { IGridPositionIndex, IPlacedDevice } from '../models/grid.model';
import { gridPositionIndexesAreEqual } from '../helpers/grid.helper';

@Pipe({
    name: 'powerTagDevices',
    standalone: false
})
export class PowerTagDevicesPipe implements PipeTransform {

  transform(devices: IPlacedDevice[], index: IGridPositionIndex): IPlacedDevice[] {
    return  devices
      ?.filter(placedDevice => placedDevice?.device?.productCharacteristicsRules?.isPowerTag)
      ?.filter(d => gridPositionIndexesAreEqual(d?.enclosureField, index));
  }

}
